import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { number, shape, string } from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';

import { withViewport } from '../../util/contextHelpers';
import { propTypes } from '../../util/types';
import { ensureCurrentUser } from '../../util/data';
import { isScrollingDisabled } from '../../ducks/UI.duck';
import { TopbarContainer } from '../../containers';
import {
  Page,
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  AccountView,
} from '../../components';

import ProfileSettingsTab from './components/ProfileSettingsTab/ProfileSettingsTab';
import css from './AccountProfilePage.module.css';

const MOBILE_MAX_WIDTH = 767;

const AccountProfilePage = (props) => {
  const { currentTab, currentUser, scrollingDisabled, viewport, intl } = props;
  const ensuredCurrentUser = ensureCurrentUser(currentUser);
  const tabs = {
    ProfileSettings: {
      tabName: 'ProfileSettings',
      routeName: 'AccountProfilePage',
      title: intl.formatMessage({ id: 'AccountProfilePage.profileSettingsTabTitle' }),
      component: <ProfileSettingsTab currentUser={ensuredCurrentUser} />,
      tipTitle: intl.formatMessage({ id: 'AccountProfilePage.profileSettingsTabTipTitle' }),
      tip: intl.formatMessage({ id: 'AccountProfilePage.profileSettingsTabTip' }),
    },
  };
  const pageTitle = intl.formatMessage({ id: 'AccountProfilePage.pageTitle' });
  const viewTitle = intl.formatMessage({ id: 'AccountProfilePage.viewTitle' });
  const isMobile = viewport.width <= MOBILE_MAX_WIDTH;

  return (
    <Page title={pageTitle} scrollingDisabled={scrollingDisabled}>
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer currentPage="AccountProfilePage" />
        </LayoutWrapperTopbar>
        <LayoutWrapperMain className={css.layoutWrapperMain}>
          <AccountView
            title={viewTitle}
            tabs={tabs}
            currentTab={currentTab}
            withoutNav
            intl={intl}
          />
        </LayoutWrapperMain>
        <LayoutWrapperFooter>{!isMobile && <Footer />}</LayoutWrapperFooter>
      </LayoutSingleColumn>
    </Page>
  );
};

AccountProfilePage.defaultProps = {};

AccountProfilePage.propTypes = {
  currentTab: string.isRequired,
  currentUser: propTypes.currentUser,
  viewport: shape({
    width: number.isRequired,
    height: number.isRequired,
  }).isRequired,
  intl: intlShape.isRequired,
};

const mapStateToProps = (state) => {
  const { currentUser } = state.user;

  return {
    currentUser,
    scrollingDisabled: isScrollingDisabled(state),
  };
};

export default compose(connect(mapStateToProps), withViewport, injectIntl)(AccountProfilePage);
